module.exports = __webpack_public_path__ + "img/four-star-logo.67694cfb.jpg";